import React, {Fragment, useEffect, useRef, useState} from 'react';
import Button from '../../Button/Button';
import LearnMore from '../../LearnMore/LearnMore';
import Link from '../../Link/Link';
import SearchNavigation from '../../SearchNavigation/SearchNavigation';
import HeaderBurger from '../HeaderBurger/HeaderBurger';
import {
	InfiosHeaderMenu,
	InfiosHeaderMenuItems,
	InfiosHeaderMenuNavigation,
	InfiosHeaderMenuWrapper
} from './HeaderNavigation.style';
import {ConditionalWrapper} from '../../../utils/ConditionalWrapper';
import targetView from "../../../utils/targetView";

const HeaderNavigation = props => {
    const { className, mouseLeave, height, content, status, resultsPage, blackLetter, backToText, overviewNavText, showSearch, hoverColor, isMobile } = props;

    const prevNameRef = useRef();
    const firstTitle = useRef(null);
    const refToScrollTopLevel1 = useRef(null);
    const refToScrollTopLevel2 = useRef(null);
    const [selectedItem, setSelectedItem] = useState("");
    const [showSecondLevel, setShowSecondLevel] = useState("");
    const [showThirdLevel, setShowThirdLevel] = useState("");
    const [openedSecond, setOpenedSecond] = useState("");
    const [openedThird, setOpenedThird] = useState("");
    const [currentText, setCurrentText] = useState("");
    const [prevText, setPrevText] = useState("");
    const [openMenu, setOpenMenu] = useState(false);
    const [menuActive, setMenuActive] = useState(false);
    const [menuSecondActive, setMenuSecondActive] = useState(false);
    const [menuThirdActive, setMenuThirdActive] = useState(false);
    const [firstTitleHeight, setFirstTitleHeight] = useState(29);

    useEffect(() => {
        if(selectedItem && selectedItem !== "" ){
            const getViewForLevel = (level) => level && level !== "" ? `-${level}` : "";
            targetView(`header-${selectedItem}${getViewForLevel(showSecondLevel)}${getViewForLevel(showThirdLevel)}`);
        }
    }, [selectedItem, showSecondLevel, showThirdLevel]);

    useEffect(() => {
        if (prevNameRef.current !== undefined && mouseLeave !== prevNameRef.current && !isMobile) {
            handleFirstLinkClick(mouseLeave);
            setShowThirdLevel(openedThird);
            setShowSecondLevel(openedSecond);
        }

        setFirstTitleHeight(firstTitle.current?.offsetHeight ? firstTitle.current.offsetHeight : 29);
        prevNameRef.current = mouseLeave;
    });

    useEffect(() => {
        setMenuSecondActive(false);
        setMenuThirdActive(false);
    }, [openMenu, menuActive, mouseLeave, selectedItem]);

    const handleFirstLinkClick = (itemName, event = null) => {
        setSelectedItem(itemName);
        setShowThirdLevel(openedThird);
        setShowSecondLevel(openedSecond);

        if (event) setPrevText(currentText);
        if (event) setCurrentText(event.target.textContent);
        if (isMobile) {
            if(refToScrollTopLevel1.current) refToScrollTopLevel1.current.scrollTop = 0;
            if(refToScrollTopLevel2.current) refToScrollTopLevel2.current.scrollTop = 0;
        }

        setFirstTitleHeight(firstTitle.current?.offsetHeight ? firstTitle.current.offsetHeight : 29);

        setMenuActive((prevState) => {
            // If the clicked item is already active, toggle the state
            if (itemName === selectedItem) {
                return !prevState;
            }
            // Otherwise, set the state to true
            return true;
        });
    };

    const handleSecondLinkClick = (itemName, textContent) => {
        setShowSecondLevel(itemName);
        setShowThirdLevel(openedThird);
        if (textContent) setPrevText(currentText);
        if (textContent) setCurrentText(textContent);
        if (isMobile) {
            if(refToScrollTopLevel1.current) refToScrollTopLevel1.current.scrollTop = 0;
            if(refToScrollTopLevel2.current) refToScrollTopLevel2.current.scrollTop = 0;
        }


        setMenuSecondActive(itemName);
        setMenuThirdActive(false);
    };

    const handleClearSecond = () => {
        setShowSecondLevel('');
        setMenuSecondActive('');
    };

    const handleThirdLinkClick = (itemName, textContent) => {
        setShowThirdLevel(itemName);
        if (textContent) setPrevText(currentText);
        if (textContent) setCurrentText(textContent);
        if (isMobile) {
            if(refToScrollTopLevel1.current) refToScrollTopLevel1.current.scrollTop = 0;
            if(refToScrollTopLevel2.current) refToScrollTopLevel2.current.scrollTop = 0;
        }

        setMenuThirdActive(itemName);
    };

    const handleClearThird = () => {
        setShowThirdLevel('');
        setMenuThirdActive('1');
    };

    const handleBackMenu = () => {
        showThirdLevel
            ? handleThirdLinkClick(null, prevText)
            : showSecondLevel
                ? handleSecondLinkClick(null)
                : handleFirstLinkClick(null);
    };

    const handleOpenMenu = () => {
        setOpenMenu(!openMenu);
        status(!openMenu);
        handleFirstLinkClick(null);
    };

    const handleCloseMenu = () => {
        setOpenMenu(false);
        status(false);
        targetView("page", true)
        handleFirstLinkClick(null);
    };

    useEffect(() => {
        const url = window.location.href.replace(/\./g, "|") + "|";
        if(content){
            for (let i = 0; i < content.length; i++) {
                const firstLevelLinks = content[i].firstLevelLinks;
                if (url.includes((content[i].overviewLink) + "|")){
                    content[i].highlightedContent = "1";
                    break
                }
                else if (firstLevelLinks) {
                    for (let j = 0; j < firstLevelLinks.length; j++) {
                        const secondLevelLinks = firstLevelLinks[j].secondLevelLinks;
                        if (url.includes(firstLevelLinks[j].firstLevelLink + "|")){
                            content[i].highlightedContent = "1";
                            content[i].firstLevelLinks[j].firstLevelHighlight = "1";
                            break
                        }
                        else if (secondLevelLinks) {
                            for (let k = 0; k < secondLevelLinks.length; k++) {
                                const thirdLevelLinks = secondLevelLinks[k].thirdLevelLinks;
                                if (url.includes(secondLevelLinks[k].secondLevelLink + "|")) {
                                    content[i].highlightedContent = "1";
                                    content[i].firstLevelLinks[j].firstLevelHighlight = "1";
                                    content[i].firstLevelLinks[j].secondLevelLinks[k].secondLevelHighlight = "1";
                                    setOpenedSecond(`item-${j}`);
                                    break;
                                } else if(thirdLevelLinks) {
                                    for (let l = 0; l < thirdLevelLinks.length; l++) {
                                        const thirdLevelLink = thirdLevelLinks[l].thirdLevelLink;
                                        if (url.includes(thirdLevelLink + "|")) {
                                            content[i].highlightedContent = "1";
                                            content[i].firstLevelLinks[j].firstLevelHighlight = "1";
                                            content[i].firstLevelLinks[j].secondLevelLinks[k].secondLevelHighlight = "1";
                                            content[i].firstLevelLinks[j].secondLevelLinks[k].thirdLevelLinks[l].thirdLevelHighlight = "1";
                                            setOpenedSecond(`item-${j}`);
                                            setOpenedThird(`item-${k}`);
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }, []);

    return (
        <InfiosHeaderMenuNavigation isMobile={isMobile} className={className} blackLetter={blackLetter}>
            {content && <HeaderBurger isMobile={isMobile} onClick={() => handleOpenMenu()} className={`burger ${openMenu ? "active" : ""}`} blackLetter={blackLetter}/>}
            {content && <InfiosHeaderMenu isMobile={isMobile} data-analytics="subheader" className={`${isMobile ? "mobile" : ""} ${openMenu ? "active" : ""}`} hoverColor={hoverColor}>
                {isMobile && showSearch && <SearchNavigation isMobile={isMobile} showSuggestions headerVersion resultsPage {...props} />}
                {
                    content.map(({
                        overviewText,
                        overviewLink,
                        overviewTargetLink,
                        overviewTitle,
                        learnMoreDescription,
                        learnMoreLinkTitle,
                        learnMoreLink,
                        learnMoreTargetLink,
                        firstLevelLinks,
                        highlightedContent
                    }, index) => {
                        return (<React.Fragment key={`item-${index}`}>
                            {(!overviewLink || firstLevelLinks) ?
                            <>
                                <ConditionalWrapper
                                    condition={!isMobile && overviewLink}
                                    wrapper={children => <a className="menuButtonWrapper" href={overviewLink} target={overviewTargetLink}>{children}</a>}>
                                        <Button
                                            className={`${!overviewLink ? "menuButtonWithChildren" : ""} ${isMobile ? "heading-3" : ""} ${highlightedContent == "1" ? "highlighted blueborder" : ""}
                                            ${openMenu ? "active" : ""}
                                            ${selectedItem === `item-${index}` ? "menu-active" : ""}`}
                                            onClick={(event) => handleFirstLinkClick(`item-${index}`, event)}
                                            onMouseEnter={(event) => {if(!isMobile){handleFirstLinkClick(`item-${index}`, event)}}}
                                            text={overviewText}
                                            tertiary
                                            icon={"play"}
                                            animated
                                            noIcon={isMobile ? null : true}
                                            hasCustomTransition
                                        />
                                </ConditionalWrapper>
                            </>
                            :
                            <Link
                                className={`stardard-link ${isMobile ? "heading-3" : ""} ${highlightedContent == "1" ? "highlighted blueborder" : ""}`}
                                link={overviewLink}
                                target={overviewTargetLink}
                                onMouseEnter={(event) => {if(!isMobile){handleFirstLinkClick(event)}}}
                                noIcon
                                text={overviewText}
                            />}

                            {selectedItem === `item-${index}` &&
                                <>
                                    <InfiosHeaderMenuItems isMobile={isMobile} ref={refToScrollTopLevel1} className={`${isMobile ? "mobile" : ""} ${openMenu ? "active" : ""} ${!!showSecondLevel || !!showThirdLevel ? 'static' : ''}`} height={height} firstTitleHeight={firstTitleHeight}>
                                        <li className={`container`}>
                                            <InfiosHeaderMenuWrapper isMobile={isMobile}>
                                                <a href={overviewLink ? overviewLink : 'javascript:void();'} target={overviewTargetLink}>
                                                    <span ref={firstTitle} className='title heading-5'>{overviewTitle}</span>
                                                </a>
                                                {
                                                    firstLevelLinks && firstLevelLinks.map(({
                                                        firstLevelText,
                                                        firstLevelLink,
                                                        firstLevelTargetLink,
                                                        firstLevelTitle,
                                                        firstLevelHighlight,
                                                        secondLevelLinks
                                                    }, index) => {
                                                        return (
                                                            <ul className='first-level' key={`firstLevelKey-${index}`}>
                                                                {(!firstLevelLink || secondLevelLinks) ? <li>
                                                                    <>
                                                                    <ConditionalWrapper
                                                                        condition={!isMobile && firstLevelLink}
                                                                        wrapper={children => <a className="" href={firstLevelLink} target={firstLevelTargetLink}>{children}</a>}>
                                                                        <Button
                                                                            onClick={() => handleSecondLinkClick(`item-${index}`, firstLevelText)}
                                                                            onMouseEnter={() =>  {if(!isMobile){handleSecondLinkClick(`item-${index}`, firstLevelText)}}}
                                                                            text={firstLevelText} tertiary icon={"play"}
                                                                            animated
                                                                            className={`p-regular
                                                                            ${firstLevelHighlight == "1" ? "highlighted" : ""} ${menuSecondActive === `item-${index}` ? "menu-active" : ""}`}/>
                                                                    </ConditionalWrapper>
                                                                    </>
                                                                    {showSecondLevel === `item-${index}` &&
                                                                        <ul className={`second-level ${!!showThirdLevel ? 'static' : ''}`} ref={refToScrollTopLevel2}>
                                                                            <li>
                                                                            <a href={firstLevelLink ? firstLevelLink : 'javascript:void();'} target={firstLevelTargetLink}>
                                                                                <span className='title heading-5'>{firstLevelTitle}</span>
                                                                            </a>
                                                                                {
                                                                                    secondLevelLinks && secondLevelLinks.map(({
                                                                                                                                secondLevelText,
                                                                                                                                secondLevelLink,
                                                                                                                                secondLevelTargetLink,
                                                                                                                                secondLevelTitle,
                                                                                                                                secondLevelHighlight,
                                                                                    thirdLevelLinks
                                                                                }, index) => {
                                                                                    return (
                                                                                        <ul className='second-level-item' key={`secondLevelKey-${index}`}>
                                                                                            {(!secondLevelLink || thirdLevelLinks) ? <li>
                                                                                                <>
                                                                                                <ConditionalWrapper
                                                                                                    condition={!isMobile && secondLevelLink}
                                                                                                    wrapper={children => <a className="" href={secondLevelLink} target={secondLevelTargetLink}>{children}</a>}>
                                                                                                    <Button
                                                                                                        onClick={() => handleThirdLinkClick(`item-${index}`, secondLevelText)}
                                                                                                        onMouseEnter={() =>  {if(!isMobile){handleThirdLinkClick(`item-${index}`, secondLevelText)}}}
                                                                                                        text={secondLevelText}
                                                                                                        tertiary icon={"play"}
                                                                                                        animated
                                                                                                        className={`p-regular ${secondLevelHighlight == "1" ? "highlighted" : ""}  ${menuThirdActive === `item-${index}` ? "menu-active" : ""}`}/>
                                                                                                </ConditionalWrapper>
                                                                                                </>
                                                                                                {showThirdLevel === `item-${index}` &&
                                                                                                    <ul className={`third-level`}>
                                                                                                        <li>
                                                                                                            <a href={secondLevelLink ? secondLevelLink : 'javascript:void();'} target={secondLevelTargetLink}>
                                                                                                                <span className='title heading-5'>{secondLevelTitle}</span>
                                                                                                            </a>
                                                                                                            <ul>
                                                                                                                {
                                                                                                                    thirdLevelLinks && thirdLevelLinks.map(({
                                                                                                                                                                thirdLevelText,
                                                                                                                                                                thirdLevelLink,
                                                                                                                                                                thirdLevelHighlight,
                                                                                                                                                                thirdLevelTargetLink
                                                                                                                }, index) => {
                                                                                                                    return (
                                                                                                                        <li key={`thirdLevelKey-${index}`}>
                                                                                                                            <Link
                                                                                                                                noIcon
                                                                                                                                link={thirdLevelLink}
                                                                                                                                text={thirdLevelText}
                                                                                                                                target={thirdLevelTargetLink}
                                                                                                                                className={`p-regular ${thirdLevelHighlight == "1" ? "highlighted" : ""}`}
                                                                                                                            />
                                                                                                                        </li>
                                                                                                                    )
                                                                                                                })
                                                                                                            }
                                                                                                        </ul>
                                                                                                    </li>
                                                                                                </ul>}
                                                                                            </li>
                                                                                            :
                                                                                            <>
                                                                                            {(!!secondLevelLink) && <li onMouseEnter={() =>  {if(!isMobile){handleClearThird()}}}>
                                                                                                <Link
                                                                                                    link={secondLevelLink}
                                                                                                    target={secondLevelTargetLink}
                                                                                                    noIcon text={secondLevelText}
                                                                                                    className={`p-regular ${secondLevelHighlight == "1" ? "highlighted" : ""}`}
                                                                                                />
                                                                                            </li>}
                                                                                            </>
                                                                                        }
                                                                                        </ul>
                                                                                    )
                                                                                })
                                                                            }
                                                                        </li>
                                                                    </ul>}
                                                                </li>
                                                            :<>
                                                            {
                                                                (!!firstLevelLink) && <li onMouseEnter={() =>  {if(!isMobile){handleClearSecond()}}}>
                                                                    <Link link={firstLevelLink} target={firstLevelTargetLink} noIcon text={firstLevelText} className={`p-regular ${firstLevelHighlight == "1" ? "highlighted" : ""}`}/>
                                                                </li>
                                                            }

                                                            </>
                                                            }
                                                            </ul>
                                                        )
                                                    })
                                                }
                                            </InfiosHeaderMenuWrapper>
                                            {learnMoreLink && !showThirdLevel && <LearnMore content={{ learnMoreDescription, learnMoreLinkTitle, learnMoreLink, learnMoreTargetLink }} />}
                                            {!isMobile && <Button className={"close"} onClick={() => handleCloseMenu()} tertiary icon="close" />}
                                            {isMobile && <span className={"close link-button"} onClick={() => handleBackMenu()}>{`${backToText} ${showSecondLevel || showThirdLevel ? currentText : overviewNavText}`}</span>}
                                        </li>
                                    </InfiosHeaderMenuItems>
                                </>
                            }
                        </React.Fragment>)
                    })
                }
            </InfiosHeaderMenu>}
        </InfiosHeaderMenuNavigation>
    )
}

export default HeaderNavigation
